module.exports = __webpack_public_path__ + "img/teaser-area-bg.e95f9482.webp";